import useRequest from '../useRequest';
/**
 * Returns ReturnDataType.
 * @param isAddToFavouritesRequestMade
 * @param getAddToFavouritesError
 * @param performAddToFavourites
 * @param addToFavouritesData
 * @param isAddToFavouritesLoading
 * @returns - ReturnDataType.
 */
const useAddToFavourites = ({ articleCode }) => {
    const { isRequestMade: isAddToFavouritesRequestMade, loading: isAddToFavouritesLoading, execute: performAddToFavourites, error: getAddToFavouritesError, data: addToFavouritesData, } = useRequest('favourites', {
        method: 'post',
        apiVersion: 1,
        manual: true,
        data: { articleCode },
    });
    return {
        isAddToFavouritesRequestMade,
        isAddToFavouritesLoading,
        performAddToFavourites,
        getAddToFavouritesError,
        addToFavouritesData,
    };
};
export default useAddToFavourites;
//# sourceMappingURL=useAddToFavourites.js.map